import { useMutation } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { authApi } from '../../authApi';
import type { RegistrationResendRequest } from '../../types';

export const useResendRegistrationCode = () =>
  useMutation({
    mutationKey: [MutationKey.AUTH_REGISTER_RESEND_CODE],
    mutationFn: (payload: RegistrationResendRequest) =>
      authApi.resendRegistrationCode(payload),
  });
